import React from "react";

const Container = (props) => (
  <ul className="list-group list-group-flush">{props.children}</ul>
);

const Item = (props) => <li className="list-group-item">{props.children}</li>;

export default { Container, Item };
